const localStorage = window.localStorage;

const save = (key: string, value: string | boolean | object, prefix?: string) => {
    try {
        prefix
            ? localStorage.setItem(`${prefix}${key}`, JSON.stringify(value))
            : localStorage.setItem(key, JSON.stringify(value));
        return value;
    } catch {
        // Intentionally left blank
    }
};

const removeItem = (key: string, prefix?: string) => {
    try {
        prefix ? localStorage.removeItem(`${prefix}${key}`) : localStorage.removeItem(key);
    } catch {
        // Intentionally left blank
    }
};

const load = (key: string, prefix?: string): string | undefined => {
    try {
        const item = prefix ? localStorage.getItem(`${prefix}${key}`) : localStorage.getItem(key);
        return item && JSON.parse(item);
    } catch {
        // Intentionally left blank
    }
};

export const storage = { save, load, removeItem };
